/**
 * All factors get an integer score 0-5
 * Categories have a weight, 0-100
 * Factors have an importance, 1-5
 * @type {String}
 */
export default {
  title: 'Lead Scoring Engine',
  categories: [
    {
      name: 'Decision Making',
      weight: 30,
      factors: [
        {
          name: 'Key decision maker involvement',
          importance: 3,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Decision makers aware of investigation', score: 1},
            {label: 'Decision makers approve of investigation', score: 2},
            {label: 'Decision makers initiated investigation', score: 3},
            {label: 'Decision makers directly involved', score: 4},
            {label: 'Decision makers leading', score: 5}
          ]
        },
        {
          name: 'Level of organization we are in direct discussions with',
          importance: 5,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Associate', score: 1},
            {label: 'Manager', score: 2},
            {label: 'Director', score: 3},
            {label: 'Vice President', score: 4},
            {label: 'CEO/Owner', score: 5}
          ]
        },
        {
          name: 'Estimated timeline to procurement',
          importance: 3,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Over 2 years', score: 1},
            {label: 'Over 1 year', score: 2},
            {label: '6-12 Months', score: 3},
            {label: '3-6 Months', score: 4},
            {label: '0-3 Months', score: 5}
          ]
        }
      ]
    },
    {
      name: 'Energy',
      weight: 20,
      factors: [
        {
          name: 'Project Size',
          importance: 5,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Less than 20 kWdc', score: 1},
            {label: '20-100 kWdc', score: 2},
            {label: '100-250 kWdc', score: 3},
            {label: '250-500 kWdc', score: 4},
            {label: 'Greater than 500 kWdc', score: 5}
          ]
        },
        {
          name: 'Electrical rate, average blended cost of electrical energy',
          importance: 5,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Less than $0.06 / kWh', score: 1},
            {label: '$0.06 - $0.08 / kWh', score: 2},
            {label: '$0.08 - $0.10 / kWh', score: 3},
            {label: '$0.10 - $0.12 / kWh', score: 4},
            {label: 'Over $0.12 / kWh', score: 5}
          ]
        },
        {
          name: 'Share of electrical bill from electrical bill from energy consumption',
          importance: 3,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Less than 60% energy costs', score: 1},
            {label: '60%-70% energy costs', score: 2},
            {label: '70%-80% energy costs', score: 3},
            {label: '$80%-90% energy costs', score: 4},
            {label: 'Over 90% energy costs', score: 5}
          ]
        }
      ]
    },
    {
      name: 'Financial',
      weight: 20,
      factors: [
        {
          name: 'Lead can monetize Investment Tax Credit',
          importance: 4,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Non-profit', score: 1},
            {label: 'No current tax appetite', score: 2},
            {label: 'Moderate tax appetite', score: 3},
            {label: 'Full tax appetite', score: 4},
            {label: 'Full tax appetite + prospect cities value of ITC', score: 5}
          ]
        },
        {
          name: 'Lead can monetize Accelerated Depreciation (MACRS + bonus)',
          importance: 3,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Non-profit', score: 1},
            {label: 'No current tax appetite', score: 2},
            {label: 'Moderate tax appetite', score: 3},
            {label: 'Full tax appetite', score: 4},
            {label: 'Full tax appetite + prospect cities value of MACRS', score: 5}
          ]
        }
      ]
    },
    {
      name: 'Technical',
      weight: 20,
      factors: [
        {
          name: 'Sufficient area exists to complete expected project size',
          importance: 4,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Area totally insufficient', score: 1},
            {label: 'Area moderately insufficient', score: 2},
            {label: 'Area marginally sufficient', score: 3},
            {label: 'Area is sufficient', score: 4},
            {label: 'Area sufficient with room for expansion', score: 5}
          ]
        },
        {
          name: 'Project area is suitable (structural, roofing, shading)',
          importance: 3,
          choices: [
            // {label: 'No Information', score: 0},
            {label: 'Totally unsuitable', score: 1},
            {label: 'Somewhat unsuitable', score: 2},
            {label: 'Marginally unsuitable', score: 3},
            {label: 'Suitable', score: 4},
            {label: 'Ideally suitable', score: 5}
          ]
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/pages/Tools/LeadScoringEngine/scoringEngineTemplate.js